import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------

  確認画面:セッション管理

--------------------------------------------------------------------------------*/

export default class tccf7SessionManager {

  /**
   * @param {string} formId - フォームID
   * @param {HTMLElement} confirmBtn - 確認ボタン要素
   */
  constructor(formId, confirmBtn = null,form) {
    this.form = form;
    this.formId = formId;
    this.confirmBtn = confirmBtn;
    this.options = window[TCCF7_CONFIG.KEY.COMMON] || {};
    this.ajaxUrl = tccf7_common?.ajax_url ?? '/wp-admin/admin-ajax.php';
  }

  /*----------------------------------------
    ボタンを取得
  ------------------------------------------*/
  refs(confirmBtn) {
    this.confirmBtn = confirmBtn;
  }

  /*----------------------------------------
    nonceを取得
  ------------------------------------------*/
  /**
   * @returns {string|null}
   */
  getNonce() {
    if (!this.confirmBtn) return null;
    const nonce = this.confirmBtn.getAttribute(TCCF7_CONFIG.ATTRIBUTES.NONCE);
    return nonce || null;
  }

  /*----------------------------------------
    AJAX送信：nonce検証
  ------------------------------------------*/
  async checkNonce() {
    const nonce = this.getNonce();
    if (!nonce) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }

    const formId = this.confirmBtn?.getAttribute(TCCF7_CONFIG.ATTRIBUTES.ID);
    if (!formId) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }

    const formData = new FormData();
    formData.append('action', TCCF7_CONFIG.ACTION.SET);
    formData.append('form_id', formId);
    formData.append('nonce', nonce);

    try {
      const response = await fetch(this.ajaxUrl, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();

      if (data.success) {
        return { success: true };
      } else {
        return { success: false, message: data.data?.message || TCCF7_CONFIG.MESSAGE.NONCE_MOVE_ERROR };
      }
    } catch (error) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }
  }

  /*----------------------------------------
    AJAX送信：セッションクリア
  ------------------------------------------*/
  async clearConfirmReady() {
    const nonce = this.getNonce();
    if (!nonce) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }
    
    const formId = this.confirmBtn?.getAttribute(TCCF7_CONFIG.ATTRIBUTES.ID);
    if (!formId) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }

    const formData = new FormData();
    formData.append('action', TCCF7_CONFIG.ACTION.CLEAR);
    formData.append('form_id', formId);
    formData.append('nonce', nonce);

    try {
      const response = await fetch(this.ajaxUrl, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      
      if (data.success) {
        return { success: true };
      }
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    } catch (error) {
      return { success: false, message: TCCF7_CONFIG.MESSAGE.NONCE_ERROR };
    }
  }
}
